module.exports = __webpack_public_path__ + "static/img/ruzhu-07.d57a5673.png";